// extracted by mini-css-extract-plugin
module.exports = {"dialog_wrapper":"modal_dialog_wrapper__2RpNL","title_wrapper":"modal_title_wrapper__2FBS1","border_bottom":"modal_border_bottom__38sHv","address":"modal_address__hBoFu"};